//Import required modules
import React from 'react';
import PropTypes from 'prop-types'

//Navbar Component
const ColorClip = (props, {store}) =>
{
    let theme = store.getState().theme;
    let colorClicked = store.getState().userWindow.colorCopied
    let docWidth = store.getState().userWindow.docWidth
    let style = {position: 'fixed',
                top: `10px`,
                right: `10px`,
                zIndex: 1}
    return (
    <div>
        <input type="text" 
                value="Hello World" 
                id="colorClicked" 
                style={{position: 'absolute',
                        left: '-9999px'}}
                onChange={() => null}></input>
        {/* <div style={style} className={`color-clip invisible ${theme}`} id='colorClipDivOld'>
            <div className='text-center'>
                <p className={`color-clip ${theme}`}>Copied!</p>
            </div>
        </div> */}
        {/* <div id='colorClipDiv'>Copied!</div>  */}
    </div>
 
    )
}

ColorClip.contextTypes = {
    store: PropTypes.object
}

export default ColorClip